(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["armband-animation"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    gsap.set('.armband', { opacity: 0, y: -220, rotateZ: -20 });
    gsap.set('.schatten', { opacity: 0, y: 0, scale: 0.7 });
    gsap.set('.feature', { opacity: 0, scale: 0.8 });

    let tl = gsap
      .timeline({
        scrollTrigger: {
          toggleActions: 'restart none none reverse',
          trigger: '.features',
          start: 'top 60%', // when the top of the trigger hits the top of the viewport
          end: '+=200', // end after scrolling 500px beyond the start
        },
      })
      .to('.armband', { opacity: 1, y: 0, rotateZ: 0, duration: 1.4 })
      .to('.schatten', { opacity: 0.5, y: 0, scale: 1, duration: 1 }, '<')
      .to('.first-circle circle', { r: 100, opacity: 0, duration: 1 }, '<50%')
      .to('.second-circle circle', { r: 50, opacity: 1, duration: 1 }, '<10%')
      .to(
        '.feature',
        {
          opacity: 1,
          scale: 1,
          duration: 0.5,
          stagger: {
            amount: 0.3,
          },
        },
        '<'
      );
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["card-slider"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {

// Falls noch nicht vorhanden, ein globales "Sammelobjekt" für bereits initialisierte Slider erstellen
    if (!window.splideInitMap) {
      window.splideInitMap = {};
    }

    var sliders = document.querySelectorAll('.card-slider');
    sliders.forEach(function(sliderElement) {
      var sliderid = sliderElement.dataset.slideid;
      if (!window.splideInitMap[sliderid]) {
        var splide = new Splide('#' + sliderid, {
          gap: 24,
          pagination: false,
          autoWidth: true,
          focus: 0
        });
        splide.mount();
        window.splideInitMap[sliderid] = true;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cta-text-video"] && !window.DesignMode) return;
  try {
    
  // document.addEventListener('DOMContentLoaded', function () {
  // var placeholders = document.querySelectorAll('.placeholder');

  // placeholders.forEach(function (placeholder) {
  // var video = placeholder.querySelector('iframe');

  // placeholder.addEventListener('click', function () {
  // if (video) {
  // placeholder.classList.add('placeholder-hide');
  // video.src += '?autoplay=1';
  // video.addEventListener('load', function () {
  // video.play();
  // });
  // }
  // });
  // });
  // });
  document.addEventListener('DOMContentLoaded', function () {
    var placeholders = document.querySelectorAll('.placeholder');

    placeholders.forEach(function (placeholder) {
      var video = document.getElementById('video');

      placeholder.addEventListener('click', function () {
        if (video) {
          placeholder.classList.add('xopacity-0');
          placeholder.classList.add('xpointer-events-none');
          video.play();
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eyecatcher-intro"] && !window.DesignMode) return;
  try {
    
  // let resizeTimeout;

// function startAnimation() {
// clearTimeout(resizeTimeout);
// resizeTimeout = setTimeout(runNetworkAnim, 500);
// }

// const TAU = 2 * Math.PI;
// const MAIN_COLOR = "#02E9D0";
// const SEC_COLOR = "#78A6FF";
// const NUM_IMAGES = 8; // Anzahl der kreisförmigen Bilder
// const NUM_DOTS = 14; // Anzahl zusätzlicher Punkte
// const DOT_SIZE = 4; // Größe der zusätzlichen Punkte
// const CONNECTION_DIST = 500;
// const MOUSE_DIST = 150;
// const MOUSE_ATTRACTION_STRENGTH = 0.04; // Stärke der Anziehung
// const ALPHA = 1;
// const MOUSE_ALPHA = 1;
// const IMAGE_SIZE = 50; // Größe der kreisförmigen Bilder

// let currentGlobalID = -1;
// let canvas = null;
// let images = []; // Array für Bilder
// let mousePosition = {
// x: 0,
// y: 0
// }; // Mausposition speichern
// let mouseActive = false;

// // Status, ob die Maus im Canvas ist
// // Statt eines einzelnen bumperElement nutzen wir nun mehrere Bumperzonen:
// let bumperZones = [];

// // Array, das alle Bumperzonen enthält

// // Setzt die Canvas-Größe passend zur .eyecatcher-intro Section
// function setCanvasSize() {
// if (canvas) {
// const eyecatcherSection = document.querySelector('.eyecatcher-intro');

// if (eyecatcherSection) {
// if (canvas.parentElement !== eyecatcherSection) {
// console.warn("For best results, the canvas should be a direct child of the eyecatcher-intro section");
// }

// const sectionWidth = eyecatcherSection.offsetWidth;
// const sectionHeight = eyecatcherSection.offsetHeight;

// canvas.style.position = 'absolute';
// canvas.style.top = '0';
// canvas.style.left = '0';
// canvas.style.zIndex = '0';

// canvas.width = sectionWidth;
// canvas.height = sectionHeight;

// console.log(`Canvas resized to match section: ${sectionWidth}x${sectionHeight}px`);
// }
// }
// }

// // Aktualisiert alle Bumperzonen anhand der Elemente mit Klasse "bumper"
// function updateBumperBounds() {
// bumperZones = [];
// const bumperElements = document.querySelectorAll(".bumper");
// const canvasRect = canvas.getBoundingClientRect();

// if (bumperElements.length > 0) {
// bumperElements.forEach(elem => {
// const rect = elem.getBoundingClientRect();
// bumperZones.push({
// x: rect.left - canvasRect.left,
// y: rect.top - canvasRect.top,
// width: rect.width,
// height: rect.height
// });
// });
// } else { // Fallback: Eine Standard-Bumperzone in der oberen Mitte
// bumperZones.push({
// x: canvas.width * 0.35,
// y: canvas.height * 0.1,
// width: canvas.width * 0.3,
// height: canvas.height * 0.3
// });
// }
// console.log("Bumper zones updated:", bumperZones);
// }

// // Prüft, ob die übergebenen Koordinaten (mit nodeSize) in einer der Bumperzonen liegen
// function isInsideAnyBumper(x, y, nodeSize) {
// for (let bumper of bumperZones) {
// if (x + nodeSize > bumper.x && x - nodeSize < bumper.x + bumper.width && y + nodeSize > bumper.y && y - nodeSize < bumper.y + bumper.height) {
// return true;
// }
// }
// return false;
// }

// // Hilfsfunktion zum Erzeugen gültiger Startkoordinaten außerhalb aller Bumperzonen
// function spawnNode(type) {
// let nodeSize = type === 'image'
// ? IMAGE_SIZE / 2
// : DOT_SIZE;
// let x,
// y;
// let attempts = 0;
// while (true) {
// if (type === 'image') {
// x = Math.random() * (canvas.width - IMAGE_SIZE) + IMAGE_SIZE / 2;
// y = Math.random() * (canvas.height * 0.5) + IMAGE_SIZE / 2;
// } else {
// x = Math.random() * canvas.width;
// y = Math.random() * (canvas.height * 0.5);
// }
// if (isInsideAnyBumper(x, y, nodeSize)) {
// attempts++;
// if (attempts > 100) { // Vermeide Endlosschleifen – gebe nach 100 Versuchen die Position zurück.
// break;
// }
// continue;
// }
// break;
// }
// return {x, y};
// }

// window.onload = function() {
// canvas = document.querySelector("#network-anim");

// // Bumperzonen werden anhand der Elemente mit Klasse "bumper" ermittelt
// updateBumperBounds();

// // Bilder laden, damit sie bereitstehen
// loadImages();

// // Canvas positionieren und Animation starten
// setCanvasSize();
// updateBumperBounds();
// startAnimation();

// // Mausbewegungen erfassen
// canvas.addEventListener('mousemove', function(e) {
// const rect = canvas.getBoundingClientRect();
// mousePosition.x = e.clientX - rect.left;
// mousePosition.y = e.clientY - rect.top;
// mouseActive = true;
// });

// canvas.addEventListener('mouseout', function() {
// mouseActive = false;
// });

// canvas.addEventListener('mouseover', function() {
// mouseActive = true;
// });
// }

// window.onresize = function() {
// setCanvasSize();
// updateBumperBounds();
// startAnimation();
// }

// // Bilder laden
// function loadImages() {
// const imageUrls = window.seniorCircleImages || [];

// imageUrls.forEach(url => {
// const img = new Image();
// img.src = url;
// images.push(img);
// });
// }

// function runNetworkAnim() {
// const currentScopeID = ++ currentGlobalID;
// const ctx = canvas.getContext("2d");

// function loop() {
// if (currentGlobalID === currentScopeID) {
// ctx.clearRect(0, 0, canvas.width, canvas.height);
// update();
// draw();
// requestAnimationFrame(loop);
// }
// }

// // Basisklasse Node mit gemeinsamer Funktionalität
// function Node(startX, startY, startVelX, startVelY) {
// this.x = startX || Math.random() * canvas.width;
// this.y = startY || Math.random() * canvas.height;
// this.vel = {
// x: startVelX || Math.random() * 2 - 1,
// y: startVelY || Math.random() * 2 - 1
// };

// this.update = function(canvas) {
// if (this.x > canvas.width + 50 || this.x<-50) {
// this.vel.x = -this.vel.x;
// }
// if (this.y>canvas.height + 50 || this.y < -50) {
// this.vel.y = -this.vel.y;
// }

// if (mouseActive) {
// const dx = mousePosition.x - this.x;
// const dy = mousePosition.y - this.y;
// const distance = Math.hypot(dx, dy);

// if (distance < MOUSE_DIST) {
// const attractionFactor = 1 - (distance / MOUSE_DIST);
// this.vel.x += (dx / distance) * attractionFactor * MOUSE_ATTRACTION_STRENGTH;
// this.vel.y += (dy / distance) * attractionFactor * MOUSE_ATTRACTION_STRENGTH;
// }
// }

// const nextX = this.x + this.vel.x / 10;
// const nextY = this.y + this.vel.y / 10;

// const nodeSize = this.type === 'image'
// ? IMAGE_SIZE / 2
// : DOT_SIZE;
// let wouldBeInBumper = false;
// let currentBumper = null;
// for (let bumper of bumperZones) {
// if (nextX + nodeSize > bumper.x && nextX - nodeSize < bumper.x + bumper.width && nextY + nodeSize > bumper.y && nextY - nodeSize < bumper.y + bumper.height) {
// wouldBeInBumper = true;
// currentBumper = bumper;
// break;
// }
// }

// if (wouldBeInBumper && currentBumper) {
// const distToLeft = Math.abs(nextX - currentBumper.x);
// const distToRight = Math.abs(nextX - (currentBumper.x + currentBumper.width));
// const distToTop = Math.abs(nextY - currentBumper.y);
// const distToBottom = Math.abs(nextY - (currentBumper.y + currentBumper.height));

// const minDist = Math.min(distToLeft, distToRight, distToTop, distToBottom);

// if (minDist === distToLeft || minDist === distToRight) {
// this.vel.x = -this.vel.x * 0.01;
// }
// if (minDist === distToTop || minDist === distToBottom) {
// this.vel.y = -this.vel.y * 0.01;
// }

// this.vel.x += Math.random() * 0.4 - 0.2;
// this.vel.y += Math.random() * 0.4 - 0.2;
// } else {
// this.x = nextX;
// this.y = nextY;
// }
// };
// }

// // ImageNode – verwendet ein Bild
// function ImageNode(startX, startY, startVelX, startVelY, imageIndex) {
// Node.call(this, startX, startY, startVelX, startVelY);
// this.imageIndex = imageIndex || 0;
// this.size = IMAGE_SIZE;
// this.type = 'image';

// this.draw = function(ctx) {
// ctx.globalAlpha = 1.0;

// try {
// ctx.save();
// ctx.beginPath();
// ctx.arc((0.5 + this.x) | 0, (0.5 + this.y) | 0, this.size / 2, 0, TAU, false);
// ctx.clip();

// const img = images[this.imageIndex];
// if (img && img.complete) {
// ctx.drawImage(img, this.x - this.size / 2, this.y - this.size / 2, this.size, this.size);
// } else {
// ctx.fillStyle = this.imageIndex % 2 === 0
// ? MAIN_COLOR
// : SEC_COLOR;
// ctx.fill();
// } ctx.restore();
// } catch (e) {
// console.error("Error drawing image:", e);
// }
// };
// }

// // DotNode – einfacher farbiger Punkt
// function DotNode(startX, startY, startVelX, startVelY) {
// Node.call(this, startX, startY, startVelX, startVelY);
// this.size = DOT_SIZE;
// this.type = 'dot';
// this.color = Math.random() > 0.5
// ? MAIN_COLOR
// : SEC_COLOR;

// this.draw = function(ctx) {
// ctx.globalAlpha = 1.0;
// ctx.beginPath();
// ctx.arc((0.5 + this.x) | 0, (0.5 + this.y) | 0, this.size, 0, TAU, false);
// ctx.fillStyle = this.color;
// ctx.fill();
// };
// }

// const nodes = [];

// // Erstelle ImageNodes mit Startpositionen außerhalb aller Bumperzonen
// for (let i = 0; i < NUM_IMAGES; i++) {
// const pos = spawnNode('image');
// nodes.push(new ImageNode(pos.x, pos.y, undefined, undefined, i % images.length));
// }

// // Erstelle DotNodes ebenfalls außerhalb aller Bumperzonen
// for (let i = 0; i < NUM_DOTS; i++) {
// const pos = spawnNode('dot');
// nodes.push(new DotNode(pos.x, pos.y));
// }

// let lastTime = Date.now();
// function update() {
// const diff = Date.now() - lastTime;
// for (let frame = 0; frame * 16.6667 < diff; frame++) {
// for (let index = 0; index < nodes.length; index++) {
// nodes[index].update(canvas);
// }
// }
// lastTime = Date.now();
// }

// function draw() {

// // // Zeichne alle Bumperzonen zur Visualisierung (kann in Produktion entfernt werden)
// // bumperZones.forEach(bumper => {
// // ctx.beginPath();
// // ctx.rect(bumper.x, bumper.y, bumper.width, bumper.height);
// // ctx.strokeStyle = "rgba(255, 255, 255, 0.2)";
// // ctx.stroke();
// // });

// // if (mouseActive) {
// // ctx.beginPath();
// // ctx.arc(mousePosition.x, mousePosition.y, MOUSE_DIST * 0.2, 0, TAU, false);
// // ctx.fillStyle = `rgba(255, 255, 255, 0.1)`;
// // ctx.fill();
// // }

// const connectionsCount = new Array(nodes.length).fill(0);

// // Zeichne Verbindungslinien (max. 4 pro Knoten)
// for (let i = 0; i < nodes.length; i++) {
// const node1 = nodes[i];
// if (connectionsCount[i] >= 4)
// continue;


// const connections = [];
// for (let j = 0; j < nodes.length; j++) {
// if (i === j || connectionsCount[j] >= 4)
// continue;


// const node2 = nodes[j];
// const dist = Math.hypot(node1.x - node2.x, node1.y - node2.y);
// if (dist < CONNECTION_DIST) {
// connections.push({index: j, distance: dist});
// }
// }
// connections.sort((a, b) => a.distance - b.distance);
// for (let k = 0; k < Math.min(connections.length, 4 - connectionsCount[i]); k++) {
// const j = connections[k].index;
// const node2 = nodes[j];
// ctx.beginPath();
// ctx.strokeStyle = "rgba(120, 166, 255, 1)";
// ctx.globalAlpha = 0.6;
// ctx.setLineDash([1, 7]);
// ctx.moveTo((0.5 + node1.x) | 0, (0.5 + node1.y) | 0);
// ctx.lineTo((0.5 + node2.x) | 0, (0.5 + node2.y) | 0);
// ctx.stroke();
// connectionsCount[i]++;
// connectionsCount[j]++;
// }
// }

// ctx.setLineDash([]);

// // Zeichne zuerst die DotNodes, damit die ImageNodes darüber liegen
// for (let i = 0; i < nodes.length; i++) {
// if (nodes[i].type === 'dot') {
// nodes[i].draw(ctx);
// }
// }
// for (let i = 0; i < nodes.length; i++) {
// if (nodes[i].type === 'image') {
// nodes[i].draw(ctx);
// }
// }
// }

// loop();
// }


  document.addEventListener('DOMContentLoaded', function() {


    const large = gsap.timeline({
      scrollTrigger: {
        trigger: ".eyecatcher-intro-image",
        scrub: 0.1,
        start: 'top 100%',
        end: 'bottom 0%',
        ease: 'none'
      }
    }).to(".eyecatcher-intro-image", {'--offset': 1});

    const rotate = gsap.timeline({
      scrollTrigger: {
        trigger: '.eyecatcher-intro ',
        scrub: 0.1,
        start: 'top 80px',
        end: 'bottom 0%'
      }
    }).fromTo('.circle-wrapper', {rotation: 0}, {
      rotation: 270,
      ease: 'none'
    })


  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
			document.body.classList.add("header-hidden");
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
			document.body.classList.remove("header-hidden");
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if(this.searchModal){ 
        this.searchModal.close(false);
      }
      
    }
  }
  
  let player = document.querySelector('lottie-player');
  let circle = document.querySelector('[data-ani-circle]');

  setTimeout(() => {
    player.play();
  }, 3000);

  setTimeout(() => {
    circle.dataset.aniCircle = true;
  }, 4000);

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var accordionItems = document.querySelectorAll('.accordion-item');

    accordionItems.forEach(function (item) {
      item.addEventListener('click', function () {
        item.classList.toggle('active');
        var accordionText = item.nextElementSibling;

        if (accordionText.classList.contains('accordion-text')) {
          if (accordionText.style.display === 'block') {
            accordionText.style.display = 'none';
          } else {
            accordionText.style.display = 'block';
          }
        }
      });
    });

    var splide = new Splide('#card-slider', {
      gap: 24,
      pagination: false,
      autoWidth: true,
      focus: 0,
    });
    splide.mount();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-process"] && !window.DesignMode) return;
  try {
    
  window.addEventListener('load', setVariables); // Initial run
  window.addEventListener('resize', setVariables); // Reponsiveness scaling

  const parents = document.querySelectorAll('.square');

  function setVariables() {
    // Modify CSS custom variables to hold current element
    // width/height per parent
    parents.forEach((el) => {
      el.style.setProperty('--parentClientWidth', el.clientWidth);
      el.style.setProperty('--parentClientHeight', el.clientHeight);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    const scrollContainer = document.querySelector('.scrollcontainer');

    const findCenteredCard = () => {
      const containerScrollLeft = scrollContainer.scrollLeft;
      const containerWidth = scrollContainer.offsetWidth;

      const children = scrollContainer.children;
      let centeredChildIndex = -1;
      let minDistanceToCenter = Infinity;

      for (let i = 0; i < children.length; i++) {
        const child = children[i];
        const childStart = child.offsetLeft;
        const childEnd = childStart + child.offsetWidth;
        const childCenter = childStart + child.offsetWidth / 2;

        const containerCenter = containerScrollLeft + containerWidth / 2;
        const distanceToCenter = Math.abs(childCenter - containerCenter);

        if (distanceToCenter < minDistanceToCenter) {
          minDistanceToCenter = distanceToCenter;
          centeredChildIndex = i;
        }
      }

      if (centeredChildIndex !== -1) {
        console.log(`Centered card index: ${centeredChildIndex}`);
        if (centeredChildIndex === 0) {
          animateStepOne();
        }
        if (centeredChildIndex === 1) {
          animateStepTwo();
        }
        if (centeredChildIndex === 2) {
          animateStepThree();
        }
        if (centeredChildIndex === 3) {
          animateStepFour();
        }
        // You can do something with the centered card here, such as adding a class to highlight it
      }
    };

    scrollContainer.addEventListener('scroll', findCenteredCard);

    const stepHeadings = document.querySelectorAll('.step');
    const stepContents = document.querySelectorAll('.step-content');
    gsap.set('.lights div', { opacity: 0 });
    gsap.set('.step02-animation', { yPercent: 50, xPercent: 50, opacity: 0 });
    gsap.set('.notruf-angenommen', { opacity: 1, yPercent: 100 });
    gsap.set('.notruf-chat', { opacity: 1, xPercent: 100 });
    gsap.set('.notruf-anruf', { opacity: 1, xPercent: 100 });

    const blinking = gsap
      .timeline({ repeat: -1, yoyo: true, paused: false })
      .fromTo('.lights div', { opacity: 0 }, { opacity: 1, stagger: 0.1 }, '+=0.5');

    const floating = gsap
      .timeline({ repeat: -1, yoyo: true })
      .fromTo('.armband-box', { yPercent: 0 }, { yPercent: 5, duration: 2, ease: 'power1.inOut' });

    const floatingCircle = gsap
      .timeline({ repeat: -1, yoyo: true })
      .fromTo('.circle', { scale: 1 }, { scale: 1.05, duration: 2, ease: 'power1.inOut' });

    const floatingNotfication = gsap
      .timeline({ repeat: -1, yoyo: true })
      .fromTo('.notfication', { yPercent: 0 }, { y: 10, duration: 2, ease: 'power1.inOut' }, '+=0.1');

    const shadowMovement = gsap
      .timeline({ repeat: -1, yoyo: true })
      .fromTo('.shadow', { scale: 1 }, { scale: 1.3, duration: 2, ease: 'power1.inOut' });
    gsap.defaults({ overwrite: true });

    function animateStepOne() {
      floatingNotfication.play();
      gsap.to('.step01-animation', { scale: 1, xPercent: 0, yPercent: 0 });
      gsap.to('.step02-animation', { yPercent: 100, xPercent: 100, opacity: 0 });
      gsap.to('.notfication', { xPercent: 0, yPercent: 0, scale: 1, opacity: 1 });
      gsap.to('.notruf-angenommen', { opacity: 1, yPercent: 100 });
      gsap.to('.notruf-anruf', { opacity: 1, xPercent: 100, yPercent: 0 });
      gsap.to('.notruf-chat', { opacity: 1, xPercent: 100 });
      gsap
        .timeline({ repeat: -1, yoyo: true, paused: false })
        .fromTo('.lights div', { opacity: 0 }, { opacity: 1, backgroundColor: 'red', stagger: 0.1 }, '+=0.5');
    }

    function animateStepTwo() {
      floatingNotfication.pause();
      gsap.to('.step01-animation', { scale: 0.5, xPercent: 0, yPercent: 0 });
      gsap.to('.step02-animation', { yPercent: 0, xPercent: 0, opacity: 1, scale: 1 });
      gsap.to('.notfication', { xPercent: -23, yPercent: -50, scale: 0.5, opacity: 1 });
      gsap.to('.notruf-angenommen', { opacity: 1, yPercent: 100 });
      gsap.to('.notruf-chat', { opacity: 1, xPercent: 100 });
      gsap.to('.lights div', { backgroundColor: 'red' });
      gsap.to('.notruf-anruf', { opacity: 1, xPercent: 100, yPercent: 0 });
      gsap
        .timeline({ repeat: -1, yoyo: true, paused: false })
        .fromTo('.lights div', { opacity: 0 }, { opacity: 1, backgroundColor: 'red', stagger: 0.1 }, '+=0.5');
    }

    function animateStepThree() {
      floatingNotfication.pause();
      gsap
        .timeline({ repeat: -1, yoyo: true, paused: false })
        .fromTo('.lights div', { opacity: 0 }, { opacity: 1, backgroundColor: 'red', stagger: 0.1 });

      gsap.to('.step01-animation', { scale: 0.5, xPercent: 0, yPercent: 0 });
      gsap.to('.step02-animation', { yPercent: 0, xPercent: 0, opacity: 1, scale: 1 });
      gsap.to('.notfication', { xPercent: -23, yPercent: -50, scale: 0, opacity: 0 });
      gsap.to('.notruf-chat', { opacity: 1, xPercent: 100 });

      const notlage = gsap
        .timeline({})
        .to('.notruf-angenommen', { opacity: 1, yPercent: 0 })
        .to('.notruf-anruf', { opacity: 1, xPercent: 0, yPercent: 0 }, '+=2')
        .fromTo(
          '.lights div',
          { opacity: 0, backgroundColor: 'green' },
          { opacity: 1, backgroundColor: 'green', stagger: 0.1 }
        );
    }

    function animateStepFour() {
      gsap.to('.step01-animation', { scale: 0.5, xPercent: -100, yPercent: -100 });
      gsap.to('.step02-animation', { yPercent: 0, xPercent: -10, opacity: 1, scale: 1.05 });
      gsap.to('.notfication', { xPercent: -23, yPercent: -50, scale: 0, opacity: 0 });
      gsap.to('.notruf-anruf', { opacity: 1, yPercent: 100 });
      gsap.to('.notruf-chat', { opacity: 1, xPercent: 0 });
    }

    stepHeadings.forEach(function (heading, index) {
      heading.addEventListener('click', function () {
        if (index === 0) {
          animateStepOne();
        }
        if (index === 1) {
          animateStepTwo();
        }
        if (index === 2) {
          animateStepThree();
        }
        if (index === 3) {
          animateStepFour();
        }
        stepHeadings.forEach(function (heading) {
          heading.classList.remove('active');
        });

        heading.classList.add('active');

        stepContents.forEach(function (content) {
          content.style.display = 'none';
        });

        stepContents[index].style.display = 'block';
      });
    });

    if (stepHeadings.length > 0) {
      stepHeadings[0].classList.add('active');
      stepContents[0].style.display = 'block';
      for (let i = 1; i < stepContents.length; i++) {
        stepContents[i].style.display = 'none';
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-showcase"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    window.addEventListener('load', setVariables); // Initial run
    window.addEventListener('resize', setVariables); // Reponsiveness scaling

    const parents = document.querySelectorAll('.square');

    function setVariables() {

// Modify CSS custom variables to hold current element
// width/height per parent
      parents.forEach((el) => {
        el.style.setProperty('--parentClientWidth', el.clientWidth);
        el.style.setProperty('--parentClientHeight', el.clientHeight);
      });
    }
    const blinking = gsap.timeline({repeat: -1, yoyo: true, paused: false}).fromTo('.lights div', {opacity: 0}, {
      opacity: 1,
      stagger: 0.1
    }, '+=0.5');
    const floating = gsap.timeline({repeat: -1, yoyo: true}).fromTo('.armband-wrapper', {yPercent: 0}, {
      yPercent: 5,
      duration: 2,
      ease: 'power1.inOut'
    });

    const shadowMovement = gsap.timeline({repeat: -1, yoyo: true}).fromTo('.shadow', {scale: 1}, {
      scale: 1.3,
      duration: 2,
      ease: 'power1.inOut'
    });
    gsap.defaults({overwrite: true});

    const rotate = gsap.timeline({
      scrollTrigger: {
        trigger: '#showcase-wrap',
        scrub: 0.2,
        start: 'top 100%',
        end: 'bottom 0%'
      }
    }).fromTo('#showcase-circle', {rotation: -130}, {
      rotation: 45,
      duration: 1,
      ease: 'none'
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-text"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var accordionItems = document.querySelectorAll('.accordion-item');

    accordionItems.forEach(function (item) {
      item.addEventListener('click', function () {
        item.classList.toggle('active');
        var accordionText = item.nextElementSibling;

        if (accordionText.classList.contains('accordion-text')) {
          if (accordionText.style.display === 'block') {
            accordionText.style.display = 'none';
          } else {
            accordionText.style.display = 'block';
          }
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-accordion"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const tabHeadings = document.querySelectorAll('.kk-section-cta-tab-accordion .tab-heading');
    const tabContents = document.querySelectorAll('.kk-section-cta-tab-accordion .tab-content');
    const accordionHeadings = document.querySelectorAll('.kk-section-cta-tab-accordion .accordion-heading');
    const accordionContainer = document.querySelectorAll('.kk-section-cta-tab-accordion .accordion-container');

    // Funktion zur Aktivierung eines Tabs
    function activateTab(tabIndex) {
      tabHeadings.forEach(function (heading) {
        heading.classList.add('inactive-tab');
      });
      tabHeadings[tabIndex].classList.remove('inactive-tab');
      tabHeadings[tabIndex].classList.add('active-tab');

      tabContents.forEach(function (content) {
        content.style.display = 'none';
      });

      tabContents[tabIndex].style.display = 'block';
    }

    // URL auf Anker überprüfen
    const hash = window.location.hash;
    let activeTabIndex = 0; // Standardmäßig Tab 1 (Index 0)

    if (hash) {
      const tabId = hash.replace('#tab', ''); // "tab6" wird zu "6"
      const tabIndex = parseInt(tabId) - 1; // Tab-Index ist nullbasiert
      if (tabIndex >= 0 && tabIndex < tabHeadings.length) {
        activeTabIndex = tabIndex;
      }
    }
    console.log(tabHeadings.length);
    // Aktiviere den entsprechenden Tab
    if (tabHeadings.length > 0) {
      activateTab(activeTabIndex);

      // Klick-Event-Listener für Tabs
      tabHeadings.forEach(function (heading, index) {
        heading.addEventListener('click', function () {
          activateTab(index);
        });
      });
    }

    let currentItem = null;

    // Klick-Event-Listener für Accordion-Headings
    accordionContainer.forEach(function (accordion, i) {
      const content = accordion.querySelector('.accordion-text');
      const heading = accordion.querySelector('.accordion-heading');

      const t = gsap
        .timeline({
          paused: true,
        })
        .to(content, {
          height: 'auto',
        })
        .to(accordionHeadings[i].querySelector('svg'), { rotate: 180 }, '<');

      heading.addEventListener('click', function () {
        t.play();
        if (currentItem === i) {
          currentItem = null;
          return t.reverse();
        } else {
          t.play();
          currentItem = i;
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-info"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const tabHeadings = document.querySelectorAll('.kk-section-cta-tab-info .tab-heading');
    const tabContents = document.querySelectorAll('.kk-section-cta-tab-info .tab-content');

    tabHeadings.forEach(function (heading, index) {
      heading.addEventListener('click', function () {
        tabHeadings.forEach(function (heading) {
          heading.classList.remove('active');
        });

        heading.classList.add('active');

        tabContents.forEach(function (content) {
          content.style.display = 'none';
        });

        tabContents[index].style.display = 'block';
      });
    });

    if (tabHeadings.length > 0) {
      tabHeadings[0].classList.add('active');
      tabContents[0].style.display = 'block';
      for (let i = 1; i < tabContents.length; i++) {
        tabContents[i].style.display = 'none';
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testemonials"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var splide = new Splide('#testemonial-slider', {
      perPage: 3,
      gap: 24,
      pagination: false,
      focus: 0,
    });
    splide.mount();
  });

  document.addEventListener('DOMContentLoaded', function () {
    var showMoreLinks = document.querySelectorAll('.show-more');
    var truncateTextElements = document.querySelectorAll('.truncate-text');
    var modal = document.getElementById('testimonialModal');
    var closeModalBtn = document.getElementById('closeModal');
    var closeModalBtn2 = document.getElementById('closeModal2');
    var slideHeight = 400; // Beispielhafte Höhe der gesamten Slide (kann angepasst werden)

    // Erstelle den Splide-Slider für das Modal
    var modalSplide = new Splide('#modalSplide', {
      type: 'slide',
      perPage: 1,
      arrows: true,
      pagination: false,
      lazyLoad: 'near',
      gap: 10,
      focus: 'center',
      speed: 0, // Anfangs sofortiges Springen ohne Animation
    });

    // Slider mounten
    modalSplide.mount();

    // Funktion zum dynamischen Truncaten des Texts basierend auf der Höhe der Slide und Bildschirmgröße
    function truncateText() {
      var isMobile = window.innerWidth < 500; // Beispielgrenze für mobile Geräte (768px)
      truncateTextElements.forEach(function (element) {
        var fullText = element.getAttribute('data-full-text');
        var titleElement = element.closest('li').querySelector('.slide-title');
        var shortTextElement = element.querySelector('.short-text');

        // Bestimme die Höhe des Titels
        var titleHeight = titleElement ? titleElement.offsetHeight : 0;

        // Verbleibende Höhe für den Text berechnen
        var remainingHeight = slideHeight - titleHeight - 60; // 60px Puffer für Abstand/Padding etc.

        // Dynamische Berechnung der Truncate-Länge
        var truncateLength;
        if (isMobile) {
          // Mobile: Bestimme die Zeichen basierend auf der verfügbaren Höhe (etwa 1.25 Zeichen pro 1px Höhe)
          truncateLength = Math.floor(remainingHeight * 1.2);
        } else {
          // Desktop: Mehr Platz pro Zeichen, etwa 2.5 Zeichen pro 1px Höhe
          truncateLength = Math.floor(remainingHeight * 1.8);
        }

        // Kürzen des Texts und anzeigen
        var shortText = fullText.length > truncateLength ? fullText.substring(0, truncateLength) + '...' : fullText;
        shortTextElement.textContent = shortText;

        // "Weiterlesen"-Button nur anzeigen, wenn der Text tatsächlich gekürzt ist
        var showMoreLink = element.querySelector('.show-more');
        if (fullText.length > truncateLength) {
          showMoreLink.style.display = 'block';
        } else {
          showMoreLink.style.display = 'none';
        }
      });
    }

    // Truncate Text bei Seitenaufruf und Fenstergrößeänderung
    truncateText();
    window.addEventListener('resize', truncateText);

    // Öffne Modal und wechsle zu der entsprechenden Bewertung im Splide
    showMoreLinks.forEach(function (link, index) {
      link.addEventListener('click', function () {
        modalSplide.options = { speed: 0 };

        // Modal anzeigen
        modal.classList.remove('xhidden');
        modal.classList.add('xflex');

        // Springe sofort zu dem entsprechenden Slide
        modalSplide.go(index);
        modalSplide.options = { speed: 1000 }; // Wechsel auf 1000ms nach dem ersten Wechsel
      });
    });

    // Schließe Modal
    closeModalBtn.addEventListener('click', function () {
      modal.classList.add('xhidden');
      modal.classList.remove('xflex');
    });
    document.getElementById('testimonialModal').addEventListener('click', function (event) {
      if (event.target.id === 'closeModal2' || event.target.closest('#closeModal2')) {
        document.getElementById('testimonialModal').classList.add('xhidden');
        document.getElementById('testimonialModal').classList.remove('xflex');
      }
    });
    // Schließe Modal beim Klicken außerhalb des Modals
    window.addEventListener('click', function (event) {
      if (event.target === modal) {
        modal.classList.add('xhidden');
        modal.classList.remove('xflex');
      }
    });
  });

  function format_number(num) {
    // Nutzt die deutsche Lokalisierung, um Punkte als Tausendertrennzeichen zu verwenden
    return num.toLocaleString('de-DE');
  }
  document.addEventListener('DOMContentLoaded', function () {
    // Finde alle Elemente mit der Klasse 'kpi'
    var kpiElements = document.querySelectorAll('.kpi');

    kpiElements.forEach(function (counter) {
      // Hole den Wert aus dem data-value Attribut
      var originalValue = parseInt(counter.dataset.value, 10);

      // Stelle sicher, dass originalValue eine gültige Zahl ist
      if (!isNaN(originalValue)) {
        var value = {
          val: 0, // Startwert für die Animation
        };

        // GSAP-Animation mit ScrollTrigger
        gsap.fromTo(
          value,
          {
            val: 0,
          },
          {
            duration: 2,
            ease: 'circ.out',
            val: originalValue,
            roundProps: 'val',
            scrollTrigger: {
              trigger: counter,
              start: 'top 80%',
            },
            onUpdate: function () {
              counter.innerText = format_number(value.val);
            },
          }
        );
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
